module.exports = __webpack_public_path__ + "img/37.0aa56988.png";